import type { JSX } from "react";

const Chevron = ({ open }: { open: boolean }): JSX.Element => (
  <svg
    width="13" height="13" viewBox="0 0 20 20" fill="none" aria-hidden="true"
    className={`transition-transform ${open ? "rotate-180" : ""}`}
  >
    <path d="M5.5 8 10 12.5 14.5 8" stroke="currentColor" strokeWidth="1.7"
      strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Chevron;
